var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGroupStops = function SvgGroupStops(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 64,
    viewBox: "0 0 58 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 4.28868C28.8094 4.11004 29.1906 4.11004 29.5 4.28868L52.7487 17.7113C53.0581 17.89 53.2487 18.2201 53.2487 18.5774V45.4226C53.2487 45.7799 53.0581 46.11 52.7487 46.2887L29.5 59.7113C29.1906 59.89 28.8094 59.89 28.5 59.7113L5.25129 46.2887C4.94189 46.11 4.75129 45.7799 4.75129 45.4226V18.5774C4.75129 18.2201 4.94189 17.89 5.25129 17.7113L28.5 4.28868Z",
    fill: "#55B8B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 2.55663C29.5718 2.02072 28.4282 2.02073 27.5 2.55663L4.25129 15.9793C3.32308 16.5152 2.75129 17.5056 2.75129 18.5774V45.4226C2.75129 46.4944 3.32309 47.4848 4.25128 48.0207L27.5 61.4434C28.4282 61.9793 29.5718 61.9793 30.5 61.4434L53.7487 48.0207C54.6769 47.4848 55.2487 46.4944 55.2487 45.4226V18.5774C55.2487 17.5055 54.6769 16.5152 53.7487 15.9793L30.5 2.55663Z",
    stroke: "#55B8B3",
    strokeOpacity: 0.4,
    strokeWidth: 4
  })));
};
export { SvgGroupStops as ReactComponent };
export default __webpack_public_path__ + "assets/1c39cc45.svg";